export default __webpack_public_path__ + "static/media/image1.2f4e4ce8.jpg";